<template>
  <Form v-slot="{ errors }" as="div">
    <p :class="$style.commentImage"><img :src="url" alt="" width="100%" /></p>
    <p :class="$style.commentTitle">この画像へのコメント</p>
    <ITextArea v-model="comment" name="comment" :rows="4" rules="max:300" />
    <div :class="$style.commentBtn">
      <IButton @click="onClickCancelButton">キャンセル</IButton>
      <IButton type="primary" :disabled="Boolean(errors.comment)" @click="onClickSaveButton">保存</IButton>
    </div>
  </Form>
</template>

<script setup lang="ts">
import { Form } from 'vee-validate';
import { ref } from 'vue';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextArea from '@/js/components/molecules/ITextArea.vue';

const props = withDefaults(
  defineProps<{
    url: string;
    text?: string;
  }>(),
  {
    text: '',
  },
);
const emit = defineEmits<{
  (e: 'cancel'): void;
  (e: 'save', comment: string): void;
}>();
const comment = ref(props.text);
const onClickCancelButton = () => {
  comment.value = props.text;
  emit('cancel');
};
const onClickSaveButton = () => {
  emit('save', comment.value);
};
</script>

<style module lang="scss">
.commentImage {
  aspect-ratio: 1 / 1;
  background-color: #f0f0f0;
  display: flex;
  margin-bottom: 20px;
  text-align: center;

  > img {
    height: 100%;
    object-fit: contain;
    width: 100%;
  }
}

.commentTitle {
  font-weight: bold;
  margin-bottom: 6px;
}

.commentBtn {
  display: grid;
  gap: 15px;
  grid-template-columns: 1fr 2fr;
  margin-top: 20px;
}
</style>
